import axios from "axios";
import { useEffect, useMemo, useState } from "react";
import appConfig from "config/appConfig";
import { verifyPermission } from "helpers/permission";
import { verifyTokenExpire } from "middleware/verifyToken";

const endPointConfig = {
  PRO: {
    plan: "PRO",
    list: `${appConfig.apiDomaine}/my/reporting-claim/config`,
  },
  MACRO: {
    holding: {
      list: `${appConfig.apiDomaine}/any/reporting-claim/config`,
    },
    filial: {
      list: `${appConfig.apiDomaine}/my/reporting-claim/config`,
    },
  },
};

export const useReportConfigData = (plan, userPermissions) => {
  const [loading, setLoading] = useState(true);
  const [rapportAuto, setRapportAuto] = useState([]);

  const endPoint = useMemo(() => {
    let endpoint = "";

    if (plan === "MACRO") {
      if (
        verifyPermission(
          userPermissions,
          "config-reporting-claim-any-institution"
        )
      ) {
        endpoint = endPointConfig[plan].holding;
      } else if (
        verifyPermission(
          userPermissions,
          "list-config-reporting-claim-my-institution"
        )
      ) {
        endpoint = endPointConfig[plan].filial;
      }
    } else {
      endpoint = endPointConfig[plan];
    }

    return endpoint;
  }, [plan, userPermissions]);

  useEffect(() => {
    const fetchData = async () => {
      if (!verifyTokenExpire() || !endPoint) return;

      try {
        setLoading(true);
        const response = await axios.get(endPoint.list);
        setRapportAuto(response.data);
      } catch (error) {
        console.error("Error fetching report config data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [endPoint]);

  return {
    loading,
    rapportAuto,
    setRapportAuto,
    endPoint,
  };
};
